import { useContext } from 'react'
import PropTypes from 'prop-types'
import { ValidationContext } from './validationContext'

function ValidationState ({ render }) {
  const value = useContext(ValidationContext)
  return value
    ? render({
      isValid: value.errors.length === 0,
      isServerValid: !value.serverError || !value.serverError.validationErrors || !value.serverError.validationErrors.length,
      errors: value.errors,
      serverError: value.serverError
    })
    : render({ isValid: true })
}

ValidationState.propTypes = {
  render: PropTypes.func.isRequired
}

export {
  ValidationState
}



// WEBPACK FOOTER //
// ./src/components/validation/validationState.js